import { render, staticRenderFns } from "./MaterialExtract.vue?vue&type=template&id=a71634d4&scoped=true&"
import script from "./MaterialExtract.vue?vue&type=script&lang=js&"
export * from "./MaterialExtract.vue?vue&type=script&lang=js&"
import style0 from "./MaterialExtract.vue?vue&type=style&index=0&id=a71634d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71634d4",
  null
  
)

export default component.exports